<ion-buttons *ngIf="isMine">
  <ion-button *ngFor="let tool of mediaTools" (click)="execute(tool)" color="primary" largeFont>
    <ion-icon [name]="tool.icon" size="large"></ion-icon>
  </ion-button>
</ion-buttons>
